import { Box } from '@mui/material';

import { ContactType } from '../types';
import Card from './Card';
import { muiStyles } from './muiStyles';

const Grid = ({
  contacts,
  postContact,
  openModal,
}: {
  contacts: ContactType[];
  postContact: (id: string, zoominfoPersonId: string) => void;
  openModal: () => void;
}) => {
  if (!contacts.length) return <>No Contacts</>;

  return (
    <Box sx={muiStyles.gridContainer}>
      {contacts.map((item) => (
        <Card key={item.zoominfoPersonId} contact={item} openModal={openModal} />
      ))}
    </Box>
  );
};

export default Grid;
